// export default App;
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Layout from "./clientAppLayout/layout";
import "./App.css";

// import Login from "./clientPages/loginPage";
import { AuthProvider } from "./component/authProvider";
import Login from "./pages/login";
import ForgotPassword from "./pages/forgotPassword";
import AdminLayout from "./component/appLayouts/clientLayout/clientLayout";
import ProtectedRoute from "./component/protectedRoute";
import Dashboard from "./pages/dashboard";
import Devis from "./pages/home";
import ClientsList from "./pages/clientsList";
import ClientsDevisList from "./pages/clientsDevisList";
import UserDetails from "./pages/clientDetails";
import DevisDetails from "./pages/devisDetails";
import Parametres from "./pages/parametres";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SignUp from "./pages/signUp.jsx";
import CreateDevisForm from "./component/CreateDevisVisitor/index.jsx";
import CreateDevisPage from "./pages/NewDevisVisitor/CreateDevisPage.jsx";
import VisitorsTable from "./component/visitorsList/index.jsx";
import DashboardAdmin from "./pages/dashboardAdmin/index.jsx";
import ConfirmationSignup from "./pages/ConfirmationSignup/ConfirmationSignup.jsx";
import SimulationListe from "./pages/simulationListe/index.jsx";
import ContactListe from "./pages/contactList/index.jsx";
import { ConfigurationTab } from "./pages/configurationTab/index.jsx";
import SimulationDetails from "./pages/detailsSimulation/index.jsx";
import ContactFormListe from "./pages/contactFormListe/index.jsx";
function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="signup" element={<SignUp />} />
          <Route path="confirmation" element={<ConfirmationSignup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-pwd" element={<ForgotPassword />} />

          {/* Protected Route for Dashboard */}
          <Route
            path="/dashboard-statistiques"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <DashboardAdmin />
                </AdminLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/config"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ConfigurationTab />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/simulation"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <SimulationListe />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/detailsSimulation/:id"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <SimulationDetails />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contact"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ContactListe />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/Form"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <ContactFormListe />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/DashboardAdmin"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <DashboardAdmin />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          {/* Home Page Route */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Devis />
              </ProtectedRoute>
            }
          />

          {/* Protect Devis route */}
          <Route
            path="/devis"
            element={
              <ProtectedRoute>
                <Devis />
              </ProtectedRoute>
            }
          />

          {/* Other Routes */}
          {/* Protected Routes for the following */}
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <ClientsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientsDevisList"
            element={
              <ProtectedRoute>
                <ClientsDevisList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/viewUser/:id"
            element={
              <ProtectedRoute>
                <UserDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devis/:id"
            element={
              <ProtectedRoute>
                <DevisDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parametres"
            element={
              <ProtectedRoute>
                <Parametres />
              </ProtectedRoute>
            }
          />
          <Route path="/create-devis" element={<CreateDevisPage />} />

          <Route
            path="/visitors-list"
            element={
              <ProtectedRoute>
                <VisitorsTable />
              </ProtectedRoute>
            }
          />
          {/* <Route path="*" element={<Navigate to="/login" />} /> */}
        </Routes>{" "}
      </AuthProvider>
    </Router>
  );
}

export default App;
